import { UnavailabilityError } from 'expo-modules-core';

// TODO: Bacon: Maybe add static functions
export default function NativeAdsManager() {
  throw new UnavailabilityError('expo-ads-facebook', 'NativeAdsManager');
}
